export const rulesPhoneNumber = (setValue, fieldName, fieldValue) => {
  setValue(
    fieldName,
    fieldValue
      ?.replace(/\D/g, '')
      .replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
      .substring(0, 13),
  );
};

export const rulesGrade = (setValue, fieldName, fieldValue) => {
  const isValidGrade = /^\d{1,3}$|^\d{1,}\.\d{0,2}$/.test(fieldValue);
  const formattedValue = isValidGrade ? fieldValue : fieldValue.slice(0, -1);

  setValue(fieldName, formattedValue);
};

export const multipartFormDataChanger = (data) => {
  if (data !== null) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    return formData;
  }
};

export const onToggleModal = (setIsOpen) => {
  setIsOpen((prev) => !prev);
};

/**
 * UUID 생성 함수
 * @returns {string} UUID 문자열
 */
export const generateUUID = () => {
  // crypto.randomUUID가 지원되는 경우 사용
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // 폴백: 간단한 UUID v4 생성
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
